import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@root/src/environments/environment';

/** Oldest or newest assignment of one process group. No safeOutputJson. */
export interface AssignmentProcessGroupEdge {
  id: string;
  name?: string | null;
  operationType: string;
  state: string;
  createdAt: string;
  resultCount?: number | null;
  progressPercentage?: number;
  error?: string | null;
}

/** One canonical process on the assignments list. */
export interface AssignmentProcessGroup {
  processDefinitionKey: string;
  assignmentCount: number;
  withResultCount: number;
  inflightCount: number;
  failedCount: number;
  earliest: AssignmentProcessGroupEdge;
  latest: AssignmentProcessGroupEdge;
}

export interface AssignmentProcessGroupQuery {
  state?: string;
  search?: string;
  processDefinitionKey?: string;
  createdFrom?: string;
  createdTo?: string;
  positiveResult?: boolean;
  worker?: string;
}

/**
 * Process groups for the assignments list.
 * TODO: migrate to api-client when assignmentsGroupsGet is generated.
 */
@Injectable({ providedIn: 'root' })
export class AssignmentProcessGroupsService {
  private readonly http = inject(HttpClient);

  load(query: AssignmentProcessGroupQuery): Observable<AssignmentProcessGroup[]> {
    let params = new HttpParams();
    params = setParam(params, 'state', query.state);
    params = setParam(params, 'search', query.search);
    params = setParam(params, 'processDefinitionKey', query.processDefinitionKey);
    params = setParam(params, 'createdFrom', query.createdFrom);
    params = setParam(params, 'createdTo', query.createdTo);
    params = setParam(params, 'worker', query.worker);
    if (query.positiveResult === true) {
      params = params.set('positiveResult', 'true');
    }
    return this.http.get<AssignmentProcessGroup[]>(`${environment.api}/assignments/groups`, { params });
  }
}

function setParam(params: HttpParams, name: string, value: string | undefined): HttpParams {
  const trimmed = value?.trim();
  return trimmed ? params.set(name, trimmed) : params;
}
